import type {ErrorProcessor, LikeError} from '../types'
import {sendOnly} from '../utils'

const MIUI = 'XiaoMi/MiuiBrowser'

export const processKnownIssues: ErrorProcessor = error => {
  if (isResizeObserverError(error as LikeError)) {
    return false
  }
  if (
    isScriptError(error as LikeError) &&
    Ya.Rum.getErrorSetting('platform') === 'touch' &&
    Ya.Rum.getErrorSetting('page')!.startsWith('route.') &&
    [`${MIUI}/14.`, `${MIUI}/13.`, 'iPhone OS 12_'].some(ua => navigator.userAgent.includes(ua))
  ) {
    return sendOnly(0.1) && error
  }

  return error
}

const SCRIPT_ERROR_MESSAGE = 'Script error.'
const isScriptError = (error: LikeError): boolean => {
  return Boolean(error.message === SCRIPT_ERROR_MESSAGE || error.originalMessage === SCRIPT_ERROR_MESSAGE)
}

const RESIZE_OBSERVER_ERROR_MESSAGES = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
]
const isResizeObserverError = (error: LikeError): boolean => {
  return RESIZE_OBSERVER_ERROR_MESSAGES.some(message => error?.message === message || error.originalMessage === message)
}
